import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { Menu } from './Composants/menu/menu';
import { Toolbar } from './Composants/toolbar/toolbar';
import { SiloParc } from './Composants/silo-parc/silo-parc';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { SyntheseConnexionService } from './Services/synthese-connexion';

// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Menu, Toolbar, SiloParc],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App {
  private readonly synthese = inject(SyntheseConnexionService);
  protected readonly title = signal('hyperion');
  protected readonly afficherSiloParc = signal(true);
  protected readonly layoutBlanc = signal(false);

  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((e) => {
        const nav = e as NavigationEnd;
        const heure = new Date().toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        console.log(
          `%c[PAGE] %c${heure} %c${nav.urlAfterRedirects}`,
          'color: #81c995; font-weight: bold',
          'color: #aaa',
          'color: inherit; font-weight: bold',
        );
        let route = this.router.routerState.snapshot.root;
        while (route.firstChild) route = route.firstChild;
        this.layoutBlanc.set(!!route.data?.['blankLayout']);
        this.afficherSiloParc.set(!route.data?.['hideSiloParc'] && !route.data?.['hideParcPanel']);
      });
  }
}
